import React, { Component, PropTypes } from 'react';
import { media } from 'style-utils';
import styled from 'styled-components';

import GlobalSearchBar from '../../features/common/GlobalSearchBar';
import Profile from '../../components/common/Profile';
import Breakpoint from '../../utils/breakpoints';
import LoginTimeOut from '../../features/login/LoginTimeOut';

const DefaultHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 52px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.color.white};
  z-index: 100;
  padding: 0 0 0 76px;
`;

const Offset = styled.div`
  position: relative;
  height: 52px;
`;

const SearchSection = styled.div`
  flex-basis: 60%;

  max-width: 1024px;
  ${media.screen`
    flex-basis: 65%;
    max-width: 1200px;
    padding: 0 10px;
    padding-left:0px;
  `};
`;
const RightSection = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
`;

class FleetHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showHistory: false
    };
  }

  homeClick = () => this.context.router.push(this.props.homeRoute);

  render() {
    return (
      <Breakpoint name="desktop">
        <Offset />
        <DefaultHeader>
          <SearchSection>
            <GlobalSearchBar
              showHistory={this.state.showHistory}
              setShowHistory={isShow => this.setState({ showHistory: isShow })}
            />
          </SearchSection>

          <RightSection>
            <Profile location={location} />
          </RightSection>
        </DefaultHeader>
        <LoginTimeOut />
      </Breakpoint>
    );
  }
}

FleetHeader.contextTypes = {
  router: PropTypes.object
};

FleetHeader.propTypes = {
  homeRoute: PropTypes.string
};

FleetHeader.defaultProps = {
  homeRoute: '/'
};

export default FleetHeader;



// WEBPACK FOOTER //
// ./src/layouts/fleet/FleetHeader.js